<template>
  <el-container style="height: 100vh;">
    <el-aside width="220px" style="background:#001529;">
      <div style="height:60px;display:flex;align-items:center;justify-content:center;">
        <span style="color:#fff;font-size:18px;font-weight:600;">YanQue</span>
      </div>
      <el-menu
        :default-active="activeMenu"
        :default-openeds="openedMenus"
        background-color="#001529"
        text-color="#ffffffa6"
        active-text-color="#ffffff"
        router
      >
        <template v-for="menu in visibleMenus">
          <el-menu-item v-if="menu.path" :key="menu.path" :index="menu.path">
            <i :class="menu.icon"></i><span>{{ menu.title }}</span>
          </el-menu-item>
          <el-submenu v-else :key="menu.index" :index="menu.index">
            <template slot="title">
              <i :class="menu.icon"></i><span>{{ menu.title }}</span>
            </template>
            <el-menu-item v-for="item in menu.children" :key="item.path" :index="item.path">
              <i :class="item.icon"></i><span>{{ item.title }}</span>
            </el-menu-item>
          </el-submenu>
        </template>
      </el-menu>
    </el-aside>

    <el-container>
      <el-header style="background:#fff;border-bottom:1px solid #f0f0f0;display:flex;align-items:center;justify-content:space-between;padding:0 24px;">
        <span style="font-size:16px;font-weight:500;">{{ $route.meta.title }}</span>
        <div style="display:flex;align-items:center;gap:12px;">
          <span style="color:#606266;font-size:14px;">{{ displayName }}</span>
          <el-button type="text" @click="handleLogout">退出登录</el-button>
        </div>
      </el-header>
      <el-main style="padding:24px;">
        <router-view />
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import { logout } from '@/api/auth'
import { clearLoginInfo, getUser, hasPermission } from '@/utils/auth'
import { MENU_PERMISSION_MAP } from '@/utils/permission'

const MENU_GROUPS = [
  {
    index: 'user-role',
    title: '用户角色管理',
    icon: 'el-icon-s-custom',
    children: [
      { path: '/user', title: '用户管理', icon: 'el-icon-user' },
      { path: '/role', title: '角色管理', icon: 'el-icon-s-check' },
      { path: '/permission', title: '权限管理', icon: 'el-icon-lock' },
      { path: '/student', title: '学生管理', icon: 'el-icon-notebook-2' }
    ]
  },
  {
    index: 'teaching',
    title: '教学管理',
    icon: 'el-icon-school',
    children: [
      { path: '/campus', title: '校区管理', icon: 'el-icon-office-building' },
      { path: '/course', title: '课程管理', icon: 'el-icon-reading' },
      { path: '/class', title: '班级管理', icon: 'el-icon-s-flag' },
      { path: '/schedule', title: '课表管理', icon: 'el-icon-date' },
      { path: '/teacher-schedule', title: '老师课表', icon: 'el-icon-s-cooperation' },
      { path: '/class-duty', title: '老师值班', icon: 'el-icon-time' },
      { path: '/homework-standard', title: '作业标准管理', icon: 'el-icon-document-checked' },
      { path: '/homework', title: '作业管理', icon: 'el-icon-edit-outline' },
      { path: '/homework-commission', title: '作业批改', icon: 'el-icon-document-checked' },
      { path: '/exam-question', title: '题库管理', icon: 'el-icon-tickets' },
      { path: '/exam-paper', title: '试卷管理', icon: 'el-icon-notebook-2' },
      { path: '/exam-test', title: '考试管理', icon: 'el-icon-date' },
      { path: '/exam-review', title: '老师阅卷', icon: 'el-icon-edit' }
    ]
  },
  {
    index: 'marketing',
    title: '营销管理',
    icon: 'el-icon-s-marketing',
    children: [
      { path: '/product', title: '产品管理', icon: 'el-icon-goods' },
      { path: '/prepayment-order', title: '预订单管理', icon: 'el-icon-s-order' },
      { path: '/order', title: '订单管理', icon: 'el-icon-document' },
      { path: '/refund-order', title: '退款订单管理', icon: 'el-icon-refresh-left' }
    ]
  },
  {
    index: 'ai-management',
    title: 'AI管理',
    icon: 'el-icon-data-analysis',
    children: [
      { path: '/text-to-sql-analysis', title: '数据分析', icon: 'el-icon-data-line' },
      { path: '/text-to-sql-runs', title: '运行记录', icon: 'el-icon-tickets' },
      { path: '/text-to-sql-permissions', title: 'Text-to-SQL 权限', icon: 'el-icon-lock' },
      { path: '/text-to-sql-eval-samples', title: '评测样本', icon: 'el-icon-document-checked' },
      { path: '/text-to-sql-eval-tasks', title: '评测任务', icon: 'el-icon-s-operation' }
    ]
  },
  {
    index: 'knowledge',
    title: '知识库',
    icon: 'el-icon-collection',
    children: [
      { path: '/knowledge-base', title: '知识库管理', icon: 'el-icon-collection' },
      { path: '/knowledge-chunks', title: '文档分段', icon: 'el-icon-document' },
      { path: '/knowledge-recall', title: '召回测试', icon: 'el-icon-search' },
      { path: '/knowledge-qa', title: '知识问答测试', icon: 'el-icon-chat-dot-round' }
    ]
  },
  {
    index: 'ai-prompt',
    title: 'AI 提示词',
    icon: 'el-icon-magic-stick',
    children: [
      { path: '/prompt-templates', title: '提示词模板', icon: 'el-icon-document-checked' },
      { path: '/prompt-tests', title: '提示词测试', icon: 'el-icon-chat-line-square' }
    ]
  },
  {
    index: 'system',
    title: '系统设置',
    icon: 'el-icon-setting',
    children: [
      { path: '/config', title: '参数管理', icon: 'el-icon-s-tools' }
    ]
  }
]

export default {
  name: 'Layout',
  computed: {
    displayName() {
      const user = getUser()
      if (!user) return '未登录'
      return user.nickname || user.realName || user.username || '用户'
    },
    visibleMenus() {
      return MENU_GROUPS
        .map(menu => {
          if (menu.path) {
            const code = MENU_PERMISSION_MAP[menu.path]
            return !code || hasPermission(code) ? menu : null
          }
          return {
            ...menu,
            children: menu.children.filter(item => {
              const code = MENU_PERMISSION_MAP[item.path]
              return !code || hasPermission(code)
            })
          }
        })
        .filter(menu => {
          if (!menu) return false
          if (menu.path) return true
          return menu.children.length > 0
        })
    },
    openedMenus() {
      return this.visibleMenus.filter(menu => menu.index).map(menu => menu.index)
    },
    activeMenu() {
      return this.$route.meta.activeMenu || this.$route.path
    }
  },
  methods: {
    handleLogout() {
      this.$confirm('确定退出登录吗？', '提示', { type: 'warning' })
        .then(async () => {
          try {
            await logout()
          } catch (e) {}
          clearLoginInfo()
          this.$message.success('已退出登录')
          this.$router.replace('/login')
        })
        .catch(() => {})
    }
  }
}
</script>

